import { Button } from '@creditornot/cb-button';
import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import { ModalHeader, ModalContent, ModalFooter } from '@creditornot/cb-modal';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { WoltModal } from 'common/components';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const Root = styled(WoltModal)`
  max-width: 566px;
  padding: 0;
  border-radius: 8px;
  background: ${cbSemanticCssVars.surfaceMain};
`;

const StyledModalFooter = styled(ModalFooter)`
  justify-content: flex-end;
`;

const ConfirmButton = styled(Button).attrs({ size: 'small', variant: 'lightRed' })``;

const CancelButton = styled(Button).attrs({ size: 'small', variant: 'lightBlue' })`
  margin-inline-end: 16px;
`;

const BundleConfirmModal = ({ onClose, onConfirm, isOpen }: Props) => {
  return (
    <Root isOpen={isOpen}>
      <ModalHeader onCloseClick={onClose}>
        <FormattedMessage id="menu-item.confirm-bundle-header" />
      </ModalHeader>
      <ModalContent>
        <FormattedMessage id="menu-item.confirm-bundle-description" />
      </ModalContent>
      <StyledModalFooter>
        <CancelButton onClick={onClose}>
          <FormattedMessage id="menu-item.cancel" />
        </CancelButton>
        <ConfirmButton onClick={onConfirm}>
          <FormattedMessage id="menu-item.confirm-bundle" />
        </ConfirmButton>
      </StyledModalFooter>
    </Root>
  );
};

export default BundleConfirmModal;
